/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDataContext } from '../../components/data';
import { getIntegrationOptionsList } from '../../services/integrations';
import { getCompanyProducts } from '../../services/companies';
import { getProducts } from '../../services/products';
import { getCampaigns } from '../../services/campaigns';
import { useMetricsLogic } from '../../hooks/useMetricsLogic';

export default function IntegrationPopover() {
  const {
    selectedCompany,
    updateCategories,
    updateIntegrationsFilter,
    updateProductsFilter,
    updateCampaignFilter,
  } = useDataContext();

  // Centraliza la carga de métricas aquí
  useMetricsLogic();

  useEffect(() => {
    if (!selectedCompany) return undefined;

    const fetchData = () => {
      getCompanyProducts(selectedCompany).then((res) => {
        if (res) updateCategories(res);
      });

      getProducts(
        selectedCompany,
        0,
        1000,
        'name desc',
        {},
        { id: true, name: true, publicKey: true }
      ).then((res) => {
        if (res) updateProductsFilter(res);
      });

      getIntegrationOptionsList(selectedCompany).then((res) => {
        if (res) updateIntegrationsFilter(res);
      });

      getCampaigns(
        selectedCompany,
        0,
        1000,
        'updatedAt DESC',
        {
          phase: ['ACTIVE', 'FINISHED'],
        },
        { id: true, name: true }
      ).then((res) => {
        if (res) updateCampaignFilter(res);
      });
    };

    fetchData();
    const interval = setInterval(fetchData, 300000); // 5 minutos
    return () => clearInterval(interval);
  }, [selectedCompany]);

  return <></>;
}
